export enum PerfMetricEnum {
    WAIT = 'WAIT',
    SQL = 'SQL',
    HOST = 'HOST',
    USER = 'USER',
    DB = 'DB',
}
